import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useRef, useEffect } from 'react';
import { ContentDisplayMode } from './interfaces';
export var useTnCBehavior = function useTnCBehavior(_ref) {
  var content = _ref.content,
    isOpen = _ref.isOpen,
    contentDisplayMode = _ref.contentDisplayMode,
    isOpenCallback = _ref.isOpenCallback;
  var inlineTncRef = useRef(null);
  var tncLinkRef = useRef(null);
  var firstRender = useRef(true);
  var _useState = useState(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    tncOpen = _useState2[0],
    setTncOpen = _useState2[1];
  useEffect(function () {
    if (!firstRender.current && contentDisplayMode === ContentDisplayMode.INLINE) {
      var _inlineTncRef$current, _tncLinkRef$current;
      /* istanbul ignore next - covered in unit test by asserting on document.activeElement */
      tncOpen ? (_inlineTncRef$current = inlineTncRef.current) === null || _inlineTncRef$current === void 0 ? void 0 : _inlineTncRef$current.focus() : (_tncLinkRef$current = tncLinkRef.current) === null || _tncLinkRef$current === void 0 ? void 0 : _tncLinkRef$current.focus();
    }

    // keeps open state in sync with host app
    isOpenCallback && isOpenCallback(tncOpen);
  }, [tncOpen]);
  useEffect(function () {
    firstRender.current = false;
  }, []);
  return {
    tncLinkRef: tncLinkRef,
    inlineTncRef: inlineTncRef,
    tncOpen: tncOpen,
    setTncOpen: setTncOpen,
    backButtonText: content.backButtonText,
    termsTitle: content.link,
    termsTextTitle: content.contentTitle,
    termsContent: content.content.json,
    cheggTermsOfUseLink: content.cheggTermsOfUseLink,
    cheggTermsOfUseText: content.cheggTermsOfUseText,
    privacyPolicyLink: content.privacyPolicyLink,
    privacyPolicyText: content.privacyPolicyText,
    tncPromptText: content.tncPromptText,
    tncPromptTextWithCoupon: content.tncPromptTextWithCoupon,
    billingHeading: content.billingHeading,
    tncPromptTextWithDuration: content.tncPromptTextWithDuration,
    planDuration: content.planDuration,
    frequency: content.frequency
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/TermsAndConditions/hooksHelper.js
// module id = 1393
// module chunks = 11